export default __webpack_public_path__ + "static/Lin_Lim-77bbcb08e6ce472970386af0cf2b6054.jpg";